import firebase from 'firebase/app'
import { leadersCol, storage } from '../firebase'

const removeDeprecatedLeaderFields = leader => {
  const payload = { ...leader }
  delete payload.expertices
  delete payload.courseG
  return payload
}

export default {
  getLeaders() {
    return leadersCol
      .where('deleted', '==', false)
      .orderBy('createdAt', 'desc')
      .get()
  },
  async pushLeader(leader, pdfFile) {
    //Uploading PDF before creating leader
    if (pdfFile) {
      let fileName = 'cv/CV-' + leader.name + '_' + leader.idNumber + '.pdf'
      let uploadResponse = await storage.child(fileName).put(pdfFile)
      if (uploadResponse) {
        let urlResponse = await uploadResponse.ref.getDownloadURL()
        if (urlResponse) {
          leader.cvUrl = urlResponse
          leader.cv = fileName
        }
      }
    }
    return leadersCol.add(removeDeprecatedLeaderFields(leader))
  },
  async updateLeader(leader, pdfFile) {
    if (leader.deleted && leader.cv) {
      storage.child(leader.cv).delete()
      leader.cv = null
      leader.cvUrl = null
    } else if (pdfFile) {
      //Uploading PDF before updating leader
      let fileName = 'cv/CV-' + leader.name + '_' + leader.idNumber + '.pdf'
      if (leader.cv && leader.cv != fileName) {
        //Removes old file if name has changed
        storage.child(leader.cv).delete()
      }

      let uploadResponse = await storage.child(fileName).put(pdfFile)

      if (uploadResponse) {
        let urlResponse = await uploadResponse.ref.getDownloadURL()
        if (urlResponse) {
          leader.cvUrl = urlResponse
          leader.cv = fileName
        }
      }
    } else if (leader.cv && !leader.cvUrl) {
      //Removes cv
      storage.child(leader.cv).delete()
      leader.cv = null
    }
    const payload = {
      ...removeDeprecatedLeaderFields(leader),
      expertices: firebase.firestore.FieldValue.delete(),
      courseG: firebase.firestore.FieldValue.delete()
    }
    return leadersCol.doc(leader.id).update(payload)
  },
  pushCVFile() {}
}
